import { render, staticRenderFns } from "./franchiseAssociateDoctor.vue?vue&type=template&id=9f342fa0&"
import script from "./franchiseAssociateDoctor.vue?vue&type=script&lang=js&"
export * from "./franchiseAssociateDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports